import { gql } from "@apollo/client";

const RESEND_CONFIRM = gql`
mutation resendConfirm($email: String!) {
  resendEmail(email: $email)
}
`

export default RESEND_CONFIRM;